﻿/** Svensk formatering av belopp, datum och antal. */

const numberFormat = new Intl.NumberFormat('sv-SE')

const dateFormat = new Intl.DateTimeFormat('sv-SE', {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
})

const timeFormat = new Intl.DateTimeFormat('sv-SE', {
  hour: '2-digit',
  minute: '2-digit',
})

export function formatSek(amount: number): string {
  return `${numberFormat.format(Math.round(amount))} kr`
}

export function formatNumber(value: number): string {
  return numberFormat.format(value)
}

/** Tar emot både ISO-sträng (YYYY-MM-DD), Date och Firestore-tidsstämpel. */
export function toDate(value: string | Date | { toDate(): Date } | null | undefined): Date | null {
  if (!value) return null
  if (value instanceof Date) return value
  if (typeof value === 'string') {
    const [y, m, d] = value.split('-').map(Number)
    if (!y || !m || !d) return null
    return new Date(y, m - 1, d)
  }
  if (typeof value.toDate === 'function') return value.toDate()
  return null
}

export function formatDate(value: string | Date | { toDate(): Date } | null | undefined): string {
  const date = toDate(value)
  return date ? dateFormat.format(date) : '–'
}

export function formatDateTime(
  value: string | Date | { toDate(): Date } | null | undefined,
): string {
  const date = toDate(value)
  return date ? `${dateFormat.format(date)} kl. ${timeFormat.format(date)}` : '–'
}

export function formatTime(value: string | Date | { toDate(): Date } | null | undefined): string {
  const date = toDate(value)
  return date ? timeFormat.format(date) : '–'
}

/** "1 dag" / "12 dagar" – används i påminnelsen om att häftet snart går ut. */
export function formatDays(days: number): string {
  return days === 1 ? '1 dag' : `${numberFormat.format(days)} dagar`
}

export function formatCount(count: number, singular: string, plural: string): string {
  return `${numberFormat.format(count)} ${count === 1 ? singular : plural}`
}

/** Initialer att visa när ett företag saknar logga. */
export function initialsFor(name: string): string {
  const words = name
    .replace(/[^\p{L}\p{N}\s]/gu, ' ')
    .split(/\s+/)
    .filter(Boolean)
  if (words.length === 0) return '?'
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase()
  return (words[0][0] + words[1][0]).toUpperCase()
}

/** Enkel, förlåtande sökmatchning: skiftlägesokänslig och accentokänslig. */
export function normalizeForSearch(value: string): string {
  return value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
}
